export const CAKE_BNB_LP_MAINNET = '0x03d9ae04F5DA332026676402442618b8B8604277'
